enum enOrderError {
    UnknownError = 'UnknownError',
    OrderNotADraft = 'OrderNotADraft',
    NoStepsDefined = 'NoStepsDefined',
    ForwardStepMissingPayloads = 'ForwardStepMissingPayloads',
    ReturnStepMissingPayloads = 'ReturnStepMissingPayloads',
    ForwardStepTooEarly = 'ForwardStepTooEarly',
    ReturnStepTooEarly = 'ReturnStepTooEarly',
    ForwardStepMissingLocation = 'ForwardStepMissingLocation',
    ReturnStepMissingLocation = 'ReturnStepMissingLocation',
    ReturnStepPayloadMissingCarrierType = 'ReturnStepPayloadMissingCarrierType',
    ReturnStepPayloadMissingCarrierCount = 'ReturnStepPayloadMissingCarrierCount',
    ForwardRouteCarrierCountOverload = 'ForwardRouteCarrierCountOverload',
    ReturnRouteCarrierCountOverload = 'ReturnRouteCarrierCountOverload',
}

export default enOrderError;
